module.exports = __webpack_public_path__ + "static/media/ProductSetup.82a02595.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/experiences/resources/ExperienceCards/ProductSetup.jpg
// module id = 3756
// module chunks = 0